"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._DeleteMarkerReplication = {
    type: "structure",
    required: [],
    members: {
        Status: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_DeleteMarkerReplication.js.map